import { Box, Grid, Typography } from "@mui/material";
import { Link } from "react-router-dom";

const CardView = ({ issueBox }) => {
  return (
    <>
      <Grid container spacing={2} className="mb-3">
        <Grid item xs={6} md={4} lg={3}>
          <Box
            sx={{
              boxShadow: `0px 0px 6px 0px #00000040`,
              borderRadius: "8px",
              cursor: "pointer",
              display: "flex",
              flexDirection: "column",
              height: "100%",
            }}
          >
            <Box style={{ height: "50%", margin: "auto" }}>
              <img src="/images/wheel.png" />
            </Box>
            <Box
              style={{
                height: "50%",
                backgroundColor: "#F8F8F8",
                padding: "16px 28px 20px 28px",
              }}
            >
              <Typography variant="h6" fontWeight={700}>
                Wheel Chocks
              </Typography>
              <span className="d-flex gap-2">
                Quantity : <Typography fontWeight={600}>30</Typography>
              </span>
              <Box className="d-flex gap-sm-3 gap-0 mt-2 mt-md-4 flex-wrap">
                <Typography fontWeight={500} color="#555555">
                  {" "}
                  Notes
                </Typography>
                <Box className="d-flex gap-1 align-items-center">
                  <Link to="/firehouse/items/detail">
                    <img
                      src="/images/eye.svg"
                      style={{ cursor: "pointer" }}
                    ></img>
                  </Link>
                  <img src="/images/edit.svg"></img>
                  <img src="/images/delete.svg"></img>
                  <img src="/images/info-icon.svg" onClick={issueBox}></img>
                </Box>
              </Box>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={6} md={4} lg={3}>
          <Box
            sx={{
              boxShadow: `0px 0px 6px 0px #00000040`,
              borderRadius: "8px",
              cursor: "pointer",
              display: "flex",
              flexDirection: "column",
              height: "100%",
            }}
          >
            <Box style={{ height: "50%", margin: "12px auto 0" }}>
              <img src="/images/extinguisher.png" />
            </Box>
            <Box
              style={{
                height: "50%",
                backgroundColor: "#F8F8F8",
                padding: "16px 28px 20px 28px",
              }}
            >
              <Typography variant="h6" fontWeight={700}>
                Firehouse
              </Typography>
              <span className="d-flex gap-2">
                Quantity : <Typography fontWeight={600}>2</Typography>
              </span>
              <Box className="d-flex gap-sm-3 gap-0 mt-2 mt-md-4 flex-wrap">
                <Typography fontWeight={500} color="#555555">
                  {" "}
                  Notes
                </Typography>
                <Box className="d-flex gap-1 align-items-center">
                  <Link to="/firehouse/items/detail">
                    <img
                      src="/images/eye.svg"
                      style={{ cursor: "pointer" }}
                    ></img>
                  </Link>
                  <img src="/images/edit.svg"></img>
                  <img src="/images/delete.svg"></img>
                  <img src="/images/info-icon.svg" onClick={issueBox}></img>
                </Box>
              </Box>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={6} md={4} lg={3}>
          <Box
            sx={{
              boxShadow: `0px 0px 6px 0px #00000040`,
              borderRadius: "8px",
              cursor: "pointer",
              display: "flex",
              flexDirection: "column",
              height: "100%",
            }}
          >
            <Box style={{ height: "50%", margin: "auto" }}>
              <img src="/images/medicine.png" />
            </Box>
            <Box
              style={{
                height: "50%",
                backgroundColor: "#F8F8F8",
                padding: "16px 28px 20px 28px",
              }}
            >
              <Typography variant="h6" fontWeight={700}>
                {" "}
                Medical
              </Typography>
              <span className="d-flex gap-2">
                Quantity : <Typography fontWeight={600}>14</Typography>
              </span>
              <Box className="d-flex gap-sm-3 gap-0 mt-2 mt-md-4 flex-wrap">
                <Typography fontWeight={500} color="#555555">
                  {" "}
                  Notes
                </Typography>
                <Box className="d-flex gap-1 align-items-center">
                  <Link to="/firehouse/items/detail">
                    <img
                      src="/images/eye.svg"
                      style={{ cursor: "pointer" }}
                    ></img>
                  </Link>
                  <img src="/images/edit.svg"></img>
                  <img src="/images/delete.svg"></img>
                  <img src="/images/info-icon.svg" onClick={issueBox}></img>
                </Box>
              </Box>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={6} md={4} lg={3}>
          <Box
            sx={{
              boxShadow: `0px 0px 6px 0px #00000040`,
              borderRadius: "8px",
              cursor: "pointer",
              display: "flex",
              flexDirection: "column",
              height: "100%",
            }}
          >
            <Box style={{ height: "50%", margin: "5px auto" }}>
              <img src="/images/wire.png" />
            </Box>
            <Box
              style={{
                height: "50%",
                backgroundColor: "#F8F8F8",
                padding: "16px 28px 20px 28px",
              }}
            >
              <Typography variant="h6" fontWeight={700}>
                {" "}
                Wire
              </Typography>
              <span className="d-flex gap-2">
                Quantity : <Typography fontWeight={600}>11</Typography>
              </span>
              <Box className="d-flex gap-sm-3 gap-0 mt-2 mt-md-4 flex-wrap">
                <Typography fontWeight={500} color="#555555">
                  {" "}
                  Notes
                </Typography>
                <Box className="d-flex gap-1 align-items-center">
                  <Link to="/firehouse/items/detail">
                    <img
                      src="/images/eye.svg"
                      style={{ cursor: "pointer" }}
                    ></img>
                  </Link>
                  <img src="/images/edit.svg"></img>
                  <img src="/images/delete.svg"></img>
                  <img src="/images/info-icon.svg" onClick={issueBox}></img>
                </Box>
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default CardView;
